var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.407,
    height: 30.721,
    viewBox: "0 0 34.407 30.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(-45.563 -346.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M46.372,360.24a.81.81,0,0,1-.715-1.189l4.547-8.6,12.114-4.233,11.308,3.4,6.209,9.37a.81.81,0,1,1-1.35.9L72.6,350.995l-10.243-3.078-11.017,3.851-4.25,8.04A.809.809,0,0,1,46.372,360.24Z",
    fill: "#8b96ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M71.081,353.136l-.175-.051-.077-.129-8.445-2.335-8.445,2.335-.078.129-.175.051-3.587,6.2v17.6h24.57v-17.6Z",
    fill: "#8b96ab"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShedIcon);
export default __webpack_public_path__ + "static/media/ShedIcon.f91b437ed017884ef3261ac8d51d4571.svg";
export { ForwardRef as ReactComponent };